// @ts-nocheck
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import PriceSpider from "@store/Library/Components/Foundation/Injectors/PriceSpider";
import React from "react";
import Page from "@insite/mobius/Page";
import Zone from "@insite/client-framework/Components/Zone";

const WhereToBuyPage = ({ id }: PageProps) => {
    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
            <PriceSpider type="Generic" /* Foundation Custom Code */ />
        </Page>
    );
};

const pageModule: PageModule = {
    component: WhereToBuyPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "Content",
    },
};

export default pageModule;
